import { Link } from "react-router-dom";
import useCache from "../../hooks/use-cache";
import useCategories from "../../hooks/use-categories";
import useLocalization from "../../hooks/use-localization";
import { useGetCountsQuery } from '../../store';

export default function CategoryNews() {

    const key = 'counts-be-category';
    const { data } = useCache(key, useGetCountsQuery);

    const localization = useLocalization();
    const cathegories = useCategories();

    if (!localization || !cathegories || !data) { return; }

    const categories = [];
    for (let prop in cathegories) {

        var categoryObj = {
            key: prop,
            name: cathegories[prop],
            count: data[prop]
        };

        categories.push(categoryObj);
    }

    categories.sort((a, b) => {
        if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
        if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }

        return 0;
    });

    const body = categories.map(c => {

        return <p key={c.key}>
            <Link to={`/news/${c.key}`}>
                {c.name} ({c.count})
            </Link>
        </p>;
    });

    return (
        <div className="footer-item">
            <span className="title-h2 title-underscore">{localization.categoryNews}</span>
            <div className="footer-text">{body}</div>
        </div>
    )
}